import { AEMScenes } from '@as-react/common-types';
import { loadContentReducer } from '../../content/reducers/ContentReducer';
import ContentSaga from '../../content/sagas/ContentSaga';
const loadContentModule = (initialData) => ({
    id: AEMScenes.CONTENT_TILE_LISTER,
    reducerMap: {
        content: loadContentReducer(initialData ? initialData.content : null),
    },
    sagas: [ContentSaga],
});
export default loadContentModule;
